module.exports = __webpack_public_path__ + "static/assets/766b4a9cfc3b39807cc0b547476956c5.png";